import {EmbedCodeExtractor} from "./types"

/** Patterns of Tik::WebEmbedService::PreProcessor::Giphy (pre_processor/giphy.rb). */
const PATTERNS = [
  /<iframe src="?https:\/\/giphy\.com\/embed\/([a-zA-Z0-9_-]+)".*/i,
  /https?:\/\/media\d+\.giphy\.com\/media\/(?:v1\.[a-zA-Z0-9]+\/)?([a-zA-Z0-9]+)\/giphy\.gif/i
]

/**
 * Converts Giphy embed iframes and `media<N>.giphy.com/media/<id>/giphy.gif` URLs to the
 * canonical `https://giphy.com/embed/<id>` URL.
 */
export const giphyPreProcessor: EmbedCodeExtractor = (input: string) => {
  for(const pattern of PATTERNS) {
    const match = pattern.exec(input)
    if(match) {
      return `https://giphy.com/embed/${match[1]}`
    }
  }
  return null
}
